import axios from 'axios';
import NProgress from 'nprogress';
import Cookie from 'js-cookie';
//import store from '@/store';

const instance = axios.create({
    baseURL: 'https://cpanel.awronore.krd/api/awronore',
});

instance.defaults.headers.common['Accept'] = 'application/json';
instance.defaults.headers.common['Accept-Language'] = 'ku-Arab';

if (Cookie.get('api')) {
    instance.defaults.headers.common['Accept-Language'] = Cookie.get('api');
}


// before a request is made start the nprogress
instance.interceptors.request.use(config => {
    NProgress.start()
    return config
})

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
    NProgress.done()
    return response
});

//instance.defaults.headers.common['Accept-Language'] = context.rootState.locale.apiLocale
export default instance;


